import React from "react";
import { Routes, Route } from "react-router-dom";
import Videos from "../../pages/Videos/Videos";
import PATH from "./../../constants/routes";
import VideoContent from "./../../pages/Videos/VideoContent";
import WatchVideo from "./../../pages/Videos/WatchVideo";

export default function VideosRoutes() {
  return (
    <Routes>
      <Route index element={<Videos />} />
      <Route path={PATH.VIDEOS_CONTENT} element={<VideoContent />} />
      <Route path={PATH.WATCH_VIDEO} element={<WatchVideo />} />
    </Routes>
  );
}
